import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { GrowthBookProvider } from "@growthbook/growthbook-react";

import MainApp from "./MainApp";
import { growthbook } from "./lib/growthbook";
import "./assets/styles/globals.css";

const container = document.getElementById("root");

if (!container) {
    throw new Error("Root container not found");
}

function AppTree() {
    return (
        <React.StrictMode>
            <GrowthBookProvider growthbook={growthbook}>
                <MainApp />
            </GrowthBookProvider>
        </React.StrictMode>
    );
}

async function bootstrap() {
    try {
        await growthbook.init({ timeout: 2000 });
    } catch (error) {
        console.error("GrowthBook initialization failed", error);
    }

    if (process.env.NODE_ENV === "development") {
        container.innerHTML = "";
        createRoot(container).render(<AppTree />);
        return;
    }

    if (container.hasChildNodes()) {
        hydrateRoot(container, <AppTree />);
    } else {
        createRoot(container).render(<AppTree />);
    }
}

bootstrap();